import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import { useAuditReportsListAodRuns } from '@mi-front/api-v2';
import { MrtTable, QueryView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { createPastRunsColumns } from '../../../components/columns/PastRunsColumns';
import { aodRoutes } from '../../../routing/routes';

interface PastRunsContentProps {
  rule: AodRule;
}

export function PastRunsContent({ rule }: PastRunsContentProps) {
  const { formatMessage } = useIntl();

  const runsQuery = useAuditReportsListAodRuns(
    {
      filter: [`rule||$eq||${rule.id}`],
      limit: 1000,
      join: ['rule'],
    },
    {
      query: {
        refetchInterval: (query) => {
          const data = query.state.data;
          const hasPending = (data?.data || []).some((run) => run.isPending);
          return hasPending ? 5000 : false;
        },
      },
    },
  );

  return (
    <QueryView query={runsQuery}>
      {({ data: runs }) => {
        return (
          <MrtTable
            data={runs}
            columns={createPastRunsColumns(formatMessage, {
              includeRuleName: false,
              includeReportLink: true,
            })}
            enablePagination
            enableFilters
            enableGlobalFilter
            enableSorting
            navigateToOnClick={(id) => aodRoutes.runView.gen(id)}
            enableExpandAll={false}
            memoizeColumns={false}
            enableHiding={false}
            enableColumnActions={false}
          />
        );
      }}
    </QueryView>
  );
}
